module.exports = __webpack_public_path__ + "SV.png?155e6a70908d4dad383e58be2c1a1239";